import { Body, Spacer } from '@spritz-finance/ui'
import { Column } from '../../Layout/Column'
import { Row } from '../../Layout/Row'
import reddit from '../../../assets/theme/quickswap/icons/Reddit.svg'
import discord from '../../../assets/theme/quickswap/icons/Discord.svg'
import twitter from '../../../assets/theme/quickswap/icons/Twitter.svg'
import medium from '../../../assets/theme/quickswap/icons/Medium.svg'
import youtube from '../../../assets/theme/quickswap/icons/Youtube.svg'
import telegram from '../../../assets/theme/quickswap/icons/Telegram.svg'
import coingecko from '../../../assets/theme/quickswap/icons/Coingecko.svg'
import styled from 'styled-components'
import React from 'react'
import { isQuickswap } from '../../../theme/utils'

const SOCIALS = [
    { id: 'reddit', icon: reddit, link: 'https://www.reddit.com/r/QuickSwap/' },
    { id: 'discord', icon: discord, link: 'https://discord.gg/dSMd7AFH36' },
    { id: 'twitter', icon: twitter, link: 'https://twitter.com/QuickswapDEX' },
    { id: 'medium', icon: medium, link: 'https://quickswap-layer2.medium.com/' },
    {
        id: 'youtube',
        icon: youtube,
        link: 'https://www.youtube.com/channel/UCrPlF-DBwD-UzLFDzJ4Z5Fw',
    },
    { id: 'telegram', icon: telegram, link: 'http://t.me/QuickSwapDEX' },
    { id: 'coingecko', icon: coingecko, link: 'https://www.coingecko.com/en/exchanges/quickswap' },
]

const SocialIcon = styled.img`
    &:hover {
        cursor: pointer;
    }
`

const Wrapper = styled(Column)``

export const QuickswapFooter = () => {
    const quickswap = isQuickswap()

    if (!quickswap) return null

    return (
        <Wrapper>
            <Spacer height={16} />
            <Row align="center" style={{ width: '100%' }}>
                {SOCIALS.map((social, index) => (
                    <React.Fragment key={social.id}>
                        <SocialIcon
                            src={social.icon}
                            onClick={() => {
                                window.open(social.link)
                            }}
                        />
                        {index !== SOCIALS.length - 1 && <Spacer width={8} />}
                    </React.Fragment>
                ))}
            </Row>
            <Spacer height={8} />
            <Row align="center" style={{ width: '100%' }}>
                <Body.Reg secondary size={12} color="#696c80">
                    © {new Date().getFullYear()} Quickswap.
                </Body.Reg>
            </Row>
            <Spacer height={16} />
        </Wrapper>
    )
}
